<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-io-title">
      {{$t('maintenance.information_obligation.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-io-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-io-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-io-name-label">
                  {{ $t('maintenance.information_obligation.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-io-form-name"
                  type="text"
                  v-model="ioForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.information_obligation.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-io-description-label">
                  {{ $t('maintenance.information_obligation.create.description_label') }}
                </label>
                <b-form-textarea
                  qid="create-io-form-description"
                  v-model="ioForm.description"
                  rows="6"
                  max-rows="6"
                  :placeholder="$t('maintenance.information_obligation.create.description_placeholder')"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group>
                <label qid="create-io-attachments-label">
                  {{ $t('maintenance.information_obligation.create.attachments') }}
                  &nbsp;
                  <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
                </label>
                <br>
                <p v-for="file in getFiles" :key="file.name">{{ file.name }}</p>
                <label class="btn btn-secondary cursor-pointer" qid="create-io-attachments-button">
                  <input type="file"
                         name="fileupload"
                         value="fileupload"
                         multiple
                         id="file-io"
                         @change="onFileChange"
                         @click="resetFile"
                  >
                  <span>
                    <font-awesome-icon icon="cloud-upload-alt" />
                    {{ $t('system.upload') }}
                  </span>
                </label>
              </b-form-group>
              <b-form-group>
                <label qid="create-io-link-label">
                  {{ $t('maintenance.information_obligation.create.links_label') }}
                </label>
                <p v-for="(link, index) in ioForm.links">
                  <span class="float-right text-muted cursor-pointer"
                        @click="removeLinkItem(index)"
                        qid="create-io-link-remove"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
                </p>
                <div>
                  <label class="mt-2">{{ $t('system.link') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLink"
                    :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                    qid="create-p-links"
                  ></b-form-input>
                  <label class="mt-2">{{ $t('table.name') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLinkName"
                    :placeholder="inputLink ? inputLink : $t('table.name')"
                    qid="create-p-links"
                  ></b-form-input>
                </div>
                <span class="btn btn-link cursor-pointer float-right"
                      @click="handleLink"
                      qid="create-io-add-link"
                >
                  <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
                </span>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-io-cancel-button"
              >
                {{ $t('maintenance.information_obligation.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        :disabled="buttonDisabled"
                        variant="success"
                        qid="create-io-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.information_obligation.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateInformationObligation',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.information_obligation.title'),
            to: '/maintenance/information-obligation'
          },
          {
            text: this.$t('maintenance.information_obligation.create.title'),
            active: true
          }
        ],
        ioForm: {
          name: '',
          description: '',
          client:'',
          links: []
        },
        error: '',
        inputLink: '',
        inputLinkName: '',
        selectedFiles: [],
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/information-obligation')
      },
      resetFile() {
        let imagefile = document.querySelector('#file-io');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file-io');

        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.ioForm.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.ioForm.links.splice(index, 1);
      },
      formSubmit(evt) {
        let formData = new FormData();
        let files = document.querySelector('#file-io');
        let sizeError = false;

        // Call handle link function to gather link from link input
        this.handleLink()

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        // Append list of attachments to FormData
        for (var i = 0; i < files.files.length; i++) {
          // Equal to 10 MB
          if (files.files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append("files[]", files.files[i]);
        }

        // Append list of links to FormData
        for (var i = 0; i < this.ioForm.links.length; i++) {
          formData.append("links[]", JSON.stringify(this.ioForm.links[i]));
        }

        formData.append("name", this.ioForm.name);
        formData.append("description", this.ioForm.description);
        formData.append("client", this.getClient.slug);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          this.buttonDisabled = true;
          // Post FormData object to API
          piincHttp.post('/information-obligations', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('maintenance.information_obligation.create.success'))
            self.buttonDisabled = false;
            self.goToList();
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              if (error.data.errors['files.0']) {
                self.error += ' ' + error.data.errors['files.0'][0]
              }
            }
          })
        }
      },
    },
    components: {

    },
    created () {

    }
  }
</script>
